import { createStyles, makeStyles } from '@material-ui/styles'
import { Theme } from '@material-ui/core'
import { fontWeights } from 'shared/style/fonts'
import colors from 'shared/style/colors'

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    modal: {
      padding: '4rem 2rem 2rem',
      '& button': {
        marginTop: '1rem',
        [theme.breakpoints.down('sm')]: {
          width: '100%'
        }
      }
    },
    title: {
      fontWeight: fontWeights.weight_600,
      [theme.breakpoints.down('sm')]: {
        marginTop: '1rem',
        textTransform: 'uppercase',
        fontSize: '1.5rem',
        textAlign: 'center'
      }
    },
    closeButton: {
      position: 'absolute',
      left: 0,
      top: 0,
      '&:focus': {
        outline: 'none'
      }
    },
    carousel: {
      width: 'inherit',
      backgroundColor: colors.background
    }
  })
)
